import React, { useEffect, useState, useRef } from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { DefaultColumnFilter } from "./filters";
import { useHistory, useLocation } from "react-router";
import usePagePosition from "../../hooks/usePagePosition";
import "./jobs-react-table.scss";

const TableContainer = ({ columns, data, name }) => {
  const history = useHistory();
  const location = useLocation();

  const [cellWidth, setCellWidth] = useState(100);
  const [cellPadding, setCellPadding] = useState("10px");
  const [yPosition, setYposition] = useState(0);
  const scrollPosition = usePagePosition();
  const inputRef = useRef();

  const scrollHandler = (_) => {
    if (inputRef.current) {
      setYposition(inputRef.current.getBoundingClientRect().y);
    }
  };

  useEffect(() => {
    if (name === "jobs") {
      setCellWidth(100);
      setCellPadding("10px");
    } else {
      setCellWidth(172);
      setCellPadding("16px");
    }

    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const handleRowClick = (row) => {
    if (name === "jobs") {
      // if (history?.location?.pathname !== "sites/:id") {
      history.push({ pathname: `/job-detail/${row.job_id}` });
    }
    if (name === "sites") {
      history.push({
        pathname: `sites/${row.address_id}`,
        data: {
          site_address: row.job_address,
          sales_by_site: row.sales_by_site,
        },
      });
    }
  };

  console.log("header", headerGroups);
  return (
    <div className="table-container-main" ref={inputRef}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                if (column?.show === 1) {
                  return null;
                } else {
                  return (
                    <th
                      {...column.getHeaderProps({
                        style: {
                          minWidth: column.minWidth,
                          width: column.width,
                        },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  );
                }
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className={`${
                  name === "tickets" ? "table-body-row1" : "table-body-row"
                } ${i % 2 === 0 ? "even" : "odd"}`}
                onClick={() => handleRowClick(row.original)}
              >
                {row.cells.map((cell) => {
                  if (cell?.column?.show === 1) {
                    return null;
                  } else {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/*<div {...getTableProps()} className="table-main">*/}
      {/*  {headerGroups.map((headerGroup) => (*/}
      {/*    <div*/}
      {/*      style={{ display: "flex" }}*/}
      {/*      className={*/}
      {/*        name === "reports"*/}
      {/*          ? ""*/}
      {/*          : yPosition && yPosition < 20*/}
      {/*          ? "header-top"*/}
      {/*          : ""*/}
      {/*      }*/}
      {/*      {...headerGroup.getHeaderGroupProps()}*/}
      {/*    >*/}
      {/*      {headerGroup.headers.map((column) => (*/}
      {/*        <div*/}
      {/*          {...column.getHeaderProps()}*/}
      {/*          className={*/}
      {/*            name === "sites" ? "sites-table-headings" : "table-headings"*/}
      {/*          }*/}
      {/*          // style={{*/}
      {/*          //   width:*/}
      {/*          //     column.id === "status"*/}
      {/*          //       ? "100px"*/}
      {/*          //       : (column.id === "id-edit") | (column.id === "select")*/}
      {/*          //       ? "50px"*/}
      {/*          //         : (column.id === "address")*/}
      {/*          //                 ? '15px'*/}
      {/*          //       : cellWidth,*/}
      {/*          // }}*/}
      {/*        >*/}
      {/*          {column.render("Header")}*/}
      {/*        </div>*/}
      {/*      ))}*/}
      {/*    </div>*/}
      {/*  ))}*/}
      {/*  <div style={{ display: "table-body" }} {...getTableBodyProps()}>*/}
      {/*    {rows.map((row, i) => {*/}
      {/*      prepareRow(row);*/}
      {/*      return (*/}
      {/*        <div*/}
      {/*          style={{*/}
      {/*            display: "flex",*/}
      {/*            //borderBottom: "1px solid #ECECEC",*/}
      {/*          }}*/}
      {/*          className={*/}
      {/*            `${name === "tickets" ? "table-body-row1" : "table-body-row"} ${i % 2 === 0 ? 'even' : 'odd'}`*/}
      {/*          }*/}
      {/*          {...row.getRowProps()}*/}
      {/*          onClick={() => handleRowClick(row.original)}*/}
      {/*        >*/}
      {/*          {row.cells.map((cell) => {*/}
      {/*            return (*/}
      {/*              <div*/}
      {/*                className={*/}
      {/*                  name === "sites"*/}
      {/*                    ? "sites-table-body-cell"*/}
      {/*                    : "table-body-cell"*/}
      {/*                }*/}
      {/*                // style={{*/}
      {/*                //   width:*/}
      {/*                //     cell.column.id === "accept-id"*/}
      {/*                //       ? "120px"*/}
      {/*                //       : (cell.column.id === "id-edit") |*/}
      {/*                //         (cell.column.id === "select")*/}
      {/*                //       ? "50px"*/}
      {/*                //       : cellWidth,*/}
      {/*                //   padding: '0px',*/}
      {/*                // }}*/}
      {/*                {...cell.getCellProps()}*/}
      {/*              >*/}
      {/*                {cell.render("Cell")}*/}
      {/*              </div>*/}
      {/*            );*/}
      {/*          })}*/}
      {/*        </div>*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default TableContainer;
